export default __webpack_public_path__ + "media/images/carnival/header_1920x1080_sp-f07c101c69667ff67e7b5aab8cce81e5.jpg";